import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Loader2, Mail, Send } from "lucide-react";
import { apiPost } from "@/lib/api";

const fmtData = (iso) => new Date(iso).toLocaleString("ro-RO", { dateStyle: "short", timeStyle: "short" });

export const ConsumEmailButton = ({ comanda }) => {
  const [sending, setSending] = useState(false);
  const [last, setLast] = useState(comanda.consum_email || null);
  const hasErp = !!(comanda.com_erp || "").trim();
  const send = async () => {
    setSending(true);
    try {
      const r = await apiPost(`/comenzi/${comanda.id}/consum-email`, {});
      setLast(r);
      toast.success(`Trimis catre ${r.to} (CC ${r.cc})`);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSending(false);
    }
  };
  return (
    <div className="flex flex-col gap-1">
      <Button
        data-testid="doc-btn-trimite-consum-corina"
        disabled={!hasErp || sending}
        onClick={send}
        className="justify-between h-auto py-3 px-4 bg-slate-900 hover:bg-slate-800 text-white"
      >
        <span className="flex items-center gap-2 font-medium"><Mail className="h-4 w-4 text-amber-400" />Trimite la Corina</span>
        {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
      </Button>
      <span className="text-xs text-slate-500" data-testid="doc-consum-email-status">
        {!hasErp
          ? "Seteaza Nr. com ERP in ecranul Comenzi pentru a trimite."
          : last
            ? `Ultima trimitere: ${fmtData(last.trimis_la)} (com. ${last.com_erp})`
            : `Netrimis. Prod_0_consum_insumat com. ${comanda.com_erp}`}
      </span>
    </div>
  );
};
